import { brl } from "@/lib/format";
import { fileUrl } from "@/lib/api";
import { esc, openPrintable } from "@/lib/pdf";

const css = (brand, font) => `
@page{margin:14mm}
body{font-family:"${font}",Georgia,serif;color:#1F1D1A;margin:0;padding:8px 18px;-webkit-print-color-adjust:exact;print-color-adjust:exact}
.head{text-align:center;padding:10px 0 18px;border-bottom:2px solid ${brand};margin-bottom:8px}
.head img{max-height:70px;max-width:200px;object-fit:contain;margin-bottom:8px}
.head h1{font-size:34px;margin:0;letter-spacing:.02em}.head p{margin:6px 0 0;color:#7A766F;font-size:13px}
.cat{break-inside:avoid-page;margin-top:26px}
.cat h2{font-size:19px;text-transform:uppercase;letter-spacing:.14em;color:${brand};margin:0 0 14px;display:flex;align-items:center;gap:14px}
.cat h2:after{content:"";flex:1;height:1px;background:${brand};opacity:.35}
.item{display:flex;gap:16px;align-items:flex-start;padding:10px 0;border-bottom:1px dotted #D8D4CC;break-inside:avoid}
.item img{width:92px;height:92px;object-fit:cover;border-radius:10px;flex-shrink:0}
.item .t{flex:1;min-width:0}.row{display:flex;align-items:baseline;gap:10px}
.row b{font-size:16px}.row .dots{flex:1;border-bottom:1px dotted #B9B4AA;transform:translateY(-4px)}
.price{font-weight:700;font-size:16px;color:${brand};white-space:nowrap}
.desc{color:#6B675F;font-size:13px;line-height:1.45;margin-top:4px}
.grid{display:grid;grid-template-columns:1fr 1fr;gap:18px}
.card{break-inside:avoid;border-radius:14px;overflow:hidden;background:#FAF8F4;border:1px solid #ECE8E0}
.card img{width:100%;height:190px;object-fit:cover;display:block}
.card .ph{height:190px;background:${brand};opacity:.12}
.card .t{padding:12px 14px}.card .row b{font-size:15px}
.foot{text-align:center;color:#9A958C;font-size:11px;margin-top:28px}`;

export function groupByCategory(recipes, cats) {
  const items = recipes.filter((r) => !r.is_base && r.sale_price > 0);
  const groups = cats.map((c) => ({ name: c.name, items: items.filter((r) => (r.menu_category || "").toLowerCase() === c.name.toLowerCase()) }));
  const known = new Set(cats.map((c) => c.name.toLowerCase()));
  groups.push({ name: "Outros", items: items.filter((r) => !known.has((r.menu_category || "").toLowerCase())) });
  return groups.filter((g) => g.items.length);
}

const photo = (r) => (r.photo_path ? `<img src="${esc(fileUrl(r.photo_path))}" alt=""/>` : "");
const head = (r) => `<div class="row"><b>${esc(r.name)}</b><span class="dots"></span><span class="price">${brl(r.sale_price)}</span></div>${r.menu_description ? `<div class="desc">${esc(r.menu_description)}</div>` : ""}`;
const listItem = (r) => `<div class="item">${photo(r)}<div class="t">${head(r)}</div></div>`;
const gridItem = (r) => `<div class="card">${photo(r) || '<div class="ph"></div>'}<div class="t">${head(r)}</div></div>`;

export function exportMenuPdf(groups, { style, title, subtitle, logoUrl, brand, font }) {
  const body = groups.map((g) => `<section class="cat"><h2>${esc(g.name)}</h2>${style === "grid" ? `<div class="grid">${g.items.map(gridItem).join("")}</div>` : g.items.map(listItem).join("")}</section>`).join("");
  const html = `<html><head><meta charset="utf-8"/><title>${esc(title)} · Cardápio</title>
  <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=${encodeURIComponent(font)}:wght@400;600;700&display=swap"/>
  <style>${css(brand, font)}</style></head><body>
  <div class="head">${logoUrl ? `<img src="${esc(logoUrl)}" alt=""/>` : ""}<h1>${esc(title)}</h1>${subtitle ? `<p>${esc(subtitle)}</p>` : ""}</div>
  ${body}
  <p class="foot">Preços em reais · sujeitos a alteração</p>
  <script>window.onload=function(){setTimeout(function(){window.print()},700)}</script>
  </body></html>`;
  return openPrintable(html);
}
